var _excluded = ["toggledFeatures"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import hoistNonReactStatics from 'hoist-non-react-statics';

/* Deprecated - use `AllhomesApiProvider` or `withAllhomesApiProvider` from `fe-co-allhomes-api` instead */
import { jsx as ___EmotionJSX } from "@emotion/core";
var toggledFeatureProvider = BaseComponent => {
  class ToggledFeatureProvided extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        toggledFeatures: this.props.toggledFeatures
      };
    }
    getChildContext() {
      return {
        toggledFeatures: this.state.toggledFeatures
      };
    }
    render() {
      var _this$props = this.props,
        toggledFeatures = _this$props.toggledFeatures,
        otherProps = _objectWithoutProperties(_this$props, _excluded); // eslint-disable-line no-unused-vars
      return ___EmotionJSX(BaseComponent, otherProps);
    }
  }
  ToggledFeatureProvided.propTypes = {
    toggledFeatures: PropTypes.objectOf(PropTypes.bool)
  };
  ToggledFeatureProvided.childContextTypes = {
    toggledFeatures: PropTypes.objectOf(PropTypes.bool)
  };
  ToggledFeatureProvided.defaultProps = {
    toggledFeatures: {}
  };
  setHOCDisplayName(ToggledFeatureProvided, BaseComponent, 'toggledFeatureProvider');
  return hoistNonReactStatics(ToggledFeatureProvided, BaseComponent);
};
export default toggledFeatureProvider;